import React, { useContext, useEffect, useState } from "react";
import DelReminderCardModal from "../../modals/delReminderCardModal";
import { getAllReminders } from "../../APIs/remindersApis";
import {
  Grid,
  InfinitySpin,
  Oval,
  Puff,
  Rings,
  RotatingLines,
} from "react-loader-spinner";
import { AppContext } from "../../context/AppContext";
import { formatTime } from "../../utils/helpers";
import { useTranslation } from "react-i18next";

const ReminderCard = ({ closeAllRemindersModal = () => {} }) => {
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  const [DeleteRemidnerid, setDeleteRemidnerid] = useState("");
  const { allreminders } = useContext(AppContext);
  const { t } = useTranslation();
  // const [allreminders, setAllReminders] = useState([]);

  const ondelClick = (id) => {
    setIsdelModalOpen(true);
    closeAllRemindersModal();
    setDeleteRemidnerid(id);
  };

  //   setTimeout(() => {
  //     getAllReminders()
  //     .then((res) => {
  //       console.log("RES:::::", res);
  //       setAllReminders(res);
  //     })
  //     .catch((err) => {

  //       console.log(err);
  //     });

  // }, []);

  return (
    <>
      {allreminders && allreminders.length > 0 ? (
        allreminders.map((reminder, index) => (
          <div
            key={reminder._id}
            className="flex flex-col items-center gap-[8px] bg-[#FBFBFB] pr-[28px] pl-[20px] py-[16px] rounded-[10px] shadow-md"
          >
            <h6 className="text-center text-blue font-manrope font-semibold">
              "{reminder.title}"
            </h6>
            <div className="flex justify-between w-full items-start gap-[10px]">
              <h6 className="font-medium text-blue font-manrope">
                {`${reminder.date} - ${formatTime(reminder.time)} `}
              </h6>
              <div className="flex gap-[10px]">
                <p className="w-[147px] bg-[#E2E4E7] rounded-[49px] text-center p-[6px] text-blue font-manrope font-medium small">
                  {t("dashboard.home.reminders.case")}: {reminder.caseType}
                </p>
                <p className="w-[147px] bg-[#E2E4E7] rounded-[49px] text-center p-[6px] text-blue font-manrope font-medium small">
                  {t("dashboard.home.reminders.priority")}: {reminder?.priority}
                </p>
              </div>
            </div>

            <div className="flex justify-between w-full items-end">
              <p className="txt-color small font-medium font-manrope flex flex-col">
                {reminder.description}
                {/* <span>{reminder.dscp2}</span> */}
              </p>
              <p
                className="cursor-pointer small font-medium font-manrope underline text-red"
                onClick={() => {
                  ondelClick(reminder._id);
                }}
              >
                {t("dashboard.home.reminders.delete")}
              </p>
            </div>
          </div>
        ))
      ) : (
        <div className="flex flex-col items-center justify-center">
          {/* <Rings
                    visible={true}
                    height="150"
                    width="150"
                    color="#143a62"
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  /> */}
          <h3 className="esmall font-semibold text-blue  my-auto">
            {t("dashboard.home.reminders.noReminders")}
            <span className="text-secondary pl-[9px]">
              {t("dashboard.home.reminders.title")}
            </span>
          </h3>
        </div>
      )}
      <DelReminderCardModal
        isdelModalOpen={isdelModalOpen}
        setIsdelModalOpen={setIsdelModalOpen}
        DeleteRemidnerid={DeleteRemidnerid}
      />
    </>
  );
};

export default ReminderCard;
